import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CMSAuthService } from '../essentials/cms/auth/cms-auth.service';
import { CMSContentService } from '../essentials/cms/content/cms-content.service';

@Component({
  template: '',
})
export class HomeComponent implements OnInit {

  constructor(
    private cmsAuthService: CMSAuthService,
    private cmsContentService: CMSContentService,
    private router: Router
  ) { }

  ngOnInit() {
    this.load();
  }

  load() {
    let token = this.cmsAuthService.getToken();
    if (!token) {
      this.cmsAuthService.auth().subscribe(response => {
        token = response.body.token_type + ' ' + response.body.access_token;
        this.cmsAuthService.setToken(token);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  getContent() {
    this.cmsContentService.getConfig().subscribe(config => {
      this.router.navigate([config.mainPage]);
    });
  }
}
